import { API_BASE_URL } from "@/config";

export default {
  name: 'ThankYouAnonymous',
  data() {
    return {
      workflows: []
    };
  },
  mounted() {
    this.check_complete_notification();
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },
  methods: {
    check_complete_notification() {
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }
      const base_url = API_BASE_URL;
      const check_complete_url = `${base_url}/verify_api/workflow_management_api/check_workflow_complete_notification_api/${this.workflow_id}`;

      fetch(check_complete_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`
        }
      }).finally(()=>{
        sessionStorage.clear(); 
        localStorage.clear();
      });
    },
  },
};
